(function() {
    if (window.__srcVariantPickerInit) return;
    window.__srcVariantPickerInit = true;

    // Auto-fit product titles to single line
    function fitTitles() {
      // Scale each card title to fill 90% of its container width (up or down),
      // clamped so short titles don't blow up and long ones stay legible.
      var MAX_SIZE = 52;   // upper limit (px) — short titles cap here
      var MIN_SIZE = 12;   // lower limit (px)
      var REF_SIZE = 24;   // measurement reference
      var TARGET = 0.80;   // fill 80% of the container width
      var titleBlocks = document.querySelectorAll('.card--block-title');
      titleBlocks.forEach(function(titleBlock) {
        var link = titleBlock.querySelector('a');
        if (!link) return;
        // The approved racing titles use responsive CSS sizing and natural wrapping.
        if (titleBlock.closest('.product-card-wrapper')) {
          link.style.removeProperty('font-size');
          return;
        }
        var textSpan = link.querySelector('.link--hover-underline') || link.querySelector('.text') || link;
        var containerWidth = titleBlock.clientWidth;
        if (containerWidth <= 0) return;
        var targetWidth = containerWidth * TARGET;
        var origDisplay = textSpan.style.display;
        textSpan.style.setProperty('display', 'inline', 'important');
        textSpan.style.setProperty('white-space', 'nowrap', 'important');
        // Measure natural width at the reference size, then scale by ratio
        link.style.setProperty('font-size', REF_SIZE + 'px', 'important');
        var measured = textSpan.offsetWidth;
        var size = measured > 0 ? REF_SIZE * (targetWidth / measured) : REF_SIZE;
        size = Math.max(MIN_SIZE, Math.min(MAX_SIZE, size));
        link.style.setProperty('font-size', size + 'px', 'important');
        textSpan.style.removeProperty('display');
        if (origDisplay) { textSpan.style.setProperty('display', origDisplay); } else { textSpan.style.removeProperty('display'); }
        textSpan.style.removeProperty('white-space');
      });
    }

    // Fully sold-out cards: hide the default badge, add a big blue SOLD OUT overlay
    function markSoldOutCards() {
      document.querySelectorAll('.src-variant-picker').forEach(function(picker){
        var atc = picker.querySelector('.src-variant-picker__atc');
        if (!atc || !/sold out/i.test(atc.textContent)) return;
        var cardRoot = picker.closest('.product-card-wrapper');
        var media = cardRoot ? cardRoot.querySelector('.card--block-media') : null;
        if (!media || media.querySelector('.mn-soldout-overlay')) return;
        media.querySelectorAll('.badge, [class*="badge"]').forEach(function(b){ if (/sold/i.test(b.textContent)) b.style.display='none'; });
        var ov = document.createElement('div');
        ov.className = 'mn-soldout-overlay';
        ov.innerHTML = '<span class="mn-soldout-banner">Sold Out</span>';
        media.appendChild(ov);
      });
    }
    function runEnhance(){
      document.querySelectorAll('[data-src-variant-picker]').forEach(function(picker) {
        rememberPriceDisplay(picker);
        // Tab content can be cloned; restore both controls from serialized state.
        picker.querySelectorAll('.src-variant-picker__option').forEach(function(group) {
          var value = selectedOptionValue(group);
          if (value !== null) setOptionValue(group, value);
        });
      });
      fitTitles();
      markSoldOutCards();
    }
    // Run on load and resize
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runEnhance);
    } else {
      runEnhance();
    }
    window.addEventListener('load', function() { setTimeout(runEnhance, 100); });
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fitTitles, 150);
    });
    // Re-run on tab switch (tab content is cloned in)
    document.addEventListener('click', function(e) {
      if (e.target.closest('.tabs-product-header__item')) { setTimeout(runEnhance, 60); setTimeout(runEnhance, 300); }
    });

    // One selected value per option drives both controls. A viewport change only
    // changes CSS visibility, so it never resets or reinterprets the selection.
    function setOptionValue(optionGroup, value) {
      optionGroup.setAttribute('data-selected-value', value);
      optionGroup.querySelectorAll('.src-variant-picker__pill').forEach(function(pill) {
        var selected = pill.getAttribute('data-option-value') === value;
        pill.classList.toggle('src-variant-picker__pill--active', selected);
        pill.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      var select = optionGroup.querySelector('.mn-card-option-select');
      if (select) select.value = value;
    }

    function selectedOptionValue(optionGroup) {
      return optionGroup.getAttribute('data-selected-value');
    }

    function clearStatus(picker) {
      clearTimeout(picker.__mnStatusTimer);
      var status = picker.querySelector('[data-atc-status]');
      if (status) {
        status.textContent = '';
        status.className = 'src-variant-picker__status';
      }
    }

    function updatePickerState(picker) {
      var atcBtn = picker.querySelector('.src-variant-picker__atc');
      if (!atcBtn) return;
      if (picker.getAttribute('data-product-available') === 'false') {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Sold Out';
        return;
      }
      var isSingle = atcBtn.hasAttribute('data-single-variant');
      var optionGroups = picker.querySelectorAll('.src-variant-picker__option');
      var allSelected = optionGroups.length > 0;
      optionGroups.forEach(function(group) {
        if (selectedOptionValue(group) === null || selectedOptionValue(group) === '') allSelected = false;
      });
      var variant = allSelected ? findMatchingVariant(picker) : null;
      if (!isSingle && optionGroups.length) {
        updateCardImage(picker);
        updatePriceDisplay(picker, variant, allSelected && !variant);
      }
      // Selection changes during an add cannot enable a second request.
      if (picker.__mnAdding) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding...';
      } else if (isSingle || variant) {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart';
      } else if (optionGroups.length) {
        atcBtn.disabled = true;
        atcBtn.textContent = allSelected ? 'Unavailable' : 'Select Options';
      }
    }

    document.addEventListener('click', function(e) {
      var pill = e.target.closest('.src-variant-picker__pill');
      if (!pill) return;
      var picker = pill.closest('.src-variant-picker');
      setOptionValue(pill.closest('.src-variant-picker__option'), pill.getAttribute('data-option-value'));
      clearStatus(picker);
      updatePickerState(picker);
    });

    document.addEventListener('change', function(e) {
      var select = e.target.closest('.mn-card-option-select');
      if (!select) return;
      var picker = select.closest('.src-variant-picker');
      setOptionValue(select.closest('.src-variant-picker__option'), select.value);
      clearStatus(picker);
      updatePickerState(picker);
    });

    // Keep card mutations and their drawer renders in order across every card.
    var cardAddQueue = Promise.resolve();

    function cartRoot() {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      if (root.charAt(0) !== '/' || root.indexOf('//') === 0) root = '/';
      return root.charAt(root.length - 1) === '/' ? root : root + '/';
    }

    function openCartPage() {
      window.location.assign(cartRoot() + 'cart');
    }

    async function addCardVariant(picker, atcBtn, variantId) {
      var statusEl = picker.querySelector('[data-atc-status]');
      var accepted = false;
      var rejectionMessage = '';
      try {
        var cartDrawer = document.querySelector('#Cart-Drawer');
        var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          body.sections = cartDrawer.getSectionsToRender().map(function(section) { return section.id; });
          var pathname = window.location.pathname || '/';
          body.sections_url = pathname.charAt(0) === '/' ? pathname : '/';
        }
        if (cartDrawer && typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(atcBtn);

        var response = await fetch(cartRoot() + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        // A successful POST is not retried when its body or drawer cannot be read.
        accepted = response.ok;
        var result = null;
        try { result = await response.json(); } catch (_) { /* Use a fresh cart page if an accepted response is unreadable. */ }
        if (!response.ok || result && Number(result.status) >= 400) {
          accepted = false;
          var status = result && Number(result.status) || response.status;
          if (status >= 400 && status < 500) {
            rejectionMessage = result && typeof result.description === 'string'
              ? result.description : 'This item could not be added to your cart.';
          }
          throw new Error('Cart add was not confirmed');
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          // The drawer validates bundled HTML and handles a fresh read/fallback.
          // Await it before releasing this card or starting the next card's POST.
          await cartDrawer.renderContents(result || {});
        } else {
          openCartPage();
        }
        statusEl.textContent = 'Added!';
        statusEl.className = 'src-variant-picker__status';
        picker.__mnStatusTimer = setTimeout(function() { statusEl.textContent = ''; }, 3000);
      } catch (error) {
        if (accepted) {
          statusEl.textContent = 'Added to your cart. Opening your cart…';
          statusEl.className = 'src-variant-picker__status';
          openCartPage();
        } else {
          statusEl.textContent = rejectionMessage || 'Could not confirm the add. Check your cart before trying again.';
          statusEl.className = 'src-variant-picker__status src-variant-picker__status--error';
        }
      } finally {
        picker.__mnAdding = false;
        updatePickerState(picker);
      }
    }

    document.addEventListener('click', function(e) {
      var atcBtn = e.target.closest('.src-variant-picker__atc');
      if (!atcBtn || atcBtn.disabled) return;
      var picker = atcBtn.closest('.src-variant-picker');
      if (picker.__mnAdding) return;
      var statusEl = picker.querySelector('[data-atc-status]');
      var variantId;
      if (atcBtn.hasAttribute('data-single-variant')) {
        variantId = atcBtn.getAttribute('data-variant-id');
      } else {
        var matchedVariant = findMatchingVariant(picker);
        variantId = matchedVariant ? matchedVariant.id : null;
      }
      if (!variantId) {
        statusEl.textContent = 'Please select all options';
        statusEl.className = 'src-variant-picker__status src-variant-picker__status--error';
        return;
      }
      // Capture the selected ID and lock immediately, including time in the queue.
      picker.__mnAdding = true;
      clearStatus(picker);
      updatePickerState(picker);
      var operation = function() { return addCardVariant(picker, atcBtn, variantId); };
      cardAddQueue = cardAddQueue.then(operation, operation);
    });

    function findCardImage(picker) {
      // The picker is inside _card-product-information, which is a sibling of _card-product-media-flex
      // Navigate up to the card root (.product-card-wrapper), then down to the image
      var cardRoot = picker.closest('.product-card-wrapper');
      if (!cardRoot) return null;
      return cardRoot.querySelector('card-media img') || cardRoot.querySelector('.card--block-media .media img');
    }

    function updateCardImage(picker) {
      var atcBtn = picker.querySelector('.src-variant-picker__atc');
      var variants;
      try { variants = JSON.parse(atcBtn.getAttribute('data-variants')); } catch(e) { return; }
      if (!variants) return;

      var selectedOptions = [];
      picker.querySelectorAll('.src-variant-picker__option').forEach(function(optGroup) {
        var value = selectedOptionValue(optGroup);
        if (value !== null && value !== '') selectedOptions.push({ index: parseInt(optGroup.getAttribute('data-option-index')), value: value });
      });
      if (selectedOptions.length === 0) return;

      // Find first variant that matches all currently selected options
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[selectedOptions[j].index] !== selectedOptions[j].value) { match = false; break; }
        }
        if (match && v.featured_image && v.featured_image.src) {
          var img = findCardImage(picker);
          if (!img) return;
          var base = v.featured_image.src.replace(/\?.*$/, '');
          img.src = base + '?width=800&format=webp';
          img.srcset = base + '?width=240&format=webp 240w, ' + base + '?width=352&format=webp 352w, ' + base + '?width=650&format=webp 650w, ' + base + '?width=832&format=webp 832w, ' + base + '?width=1200&format=webp 1200w';
          img.alt = v.featured_image.alt || '';
          return;
        }
      }
    }

    function findMatchingVariant(picker) {
      var atcBtn = picker.querySelector('.src-variant-picker__atc');
      var variants;
      try {
        variants = JSON.parse(atcBtn.getAttribute('data-variants'));
      } catch(e) { return null; }
      if (!Array.isArray(variants)) return null;

      var selectedOptions = [];
      picker.querySelectorAll('.src-variant-picker__option').forEach(function(optGroup) {
        var value = selectedOptionValue(optGroup);
        if (value !== null && value !== '') selectedOptions.push(value);
      });

      var optionsCount = parseInt(atcBtn.getAttribute('data-options-count'));
      if (selectedOptions.length !== optionsCount) return null;

      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[j] !== selectedOptions[j]) { match = false; break; }
        }
        if (match && v.available) return v;
        if (match && !v.available) return null;
      }
      return null;
    }

    // Keep the server-rendered minimum quote until a complete, available
    // variant is selected, and restore it when a combination is unavailable.
    function rememberPriceDisplay(picker) {
      var cardBlock = picker.closest('.card--block');
      if (!cardBlock || picker.__mnInitialPrice) return;
      var priceRow = cardBlock.querySelector('.src-price-row__price');
      var pillPrice = cardBlock.querySelector('[data-src-pill-price]');
      var entryCounter = cardBlock.querySelector('[data-mn-giveaway-cents]');
      picker.__mnInitialPrice = {
        priceHTML: priceRow ? priceRow.innerHTML : null,
        pillText: pillPrice ? pillPrice.textContent : null,
        cents: entryCounter ? entryCounter.getAttribute('data-mn-giveaway-cents') : null,
        variantId: entryCounter ? entryCounter.getAttribute('data-mn-variant-id') : null,
        ineligible: entryCounter ? entryCounter.getAttribute('data-mn-ineligible') : null
      };
    }

    function formatCardMoney(cents) {
      var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD';
      var options = {
        style: 'currency', currency: currency,
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      };
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', options).format(cents / 100);
      } catch (error) {
        options.currency = 'USD';
        return new Intl.NumberFormat('en-US', options).format(cents / 100);
      }
    }

    function updatePriceDisplay(picker, variant, ineligible) {
      var cardBlock = picker.closest('.card--block');
      if (!cardBlock) return;
      rememberPriceDisplay(picker);
      var initial = picker.__mnInitialPrice;
      var priceRow = cardBlock.querySelector('.src-price-row__price');
      var pillPrice = cardBlock.querySelector('[data-src-pill-price]');
      var entryCounter = cardBlock.querySelector('[data-mn-giveaway-cents]');

      if (!variant) {
        if (priceRow && initial.priceHTML !== null) priceRow.innerHTML = initial.priceHTML;
        if (pillPrice && initial.pillText !== null) pillPrice.textContent = initial.pillText;
        if (entryCounter) {
          entryCounter.setAttribute('data-mn-giveaway-cents', initial.cents);
          if (initial.variantId !== null) entryCounter.setAttribute('data-mn-variant-id', initial.variantId);
          else entryCounter.removeAttribute('data-mn-variant-id');
          entryCounter.removeAttribute('data-mn-entry-from');
          if (ineligible || initial.ineligible === 'true') entryCounter.setAttribute('data-mn-ineligible', 'true');
          else entryCounter.removeAttribute('data-mn-ineligible');
        }
        if (window.MNGiveaway) window.MNGiveaway.render();
        return;
      }

      var cents = Number(variant.price);
      var formatted = formatCardMoney(cents);
      var compareAt = Number(variant.compare_at_price) || 0;
      var onSale = compareAt > cents;

      if (pillPrice) pillPrice.textContent = formatted;
      if (entryCounter) {
        entryCounter.setAttribute('data-mn-giveaway-cents', String(cents));
        entryCounter.setAttribute('data-mn-variant-id', String(variant.id));
        entryCounter.removeAttribute('data-mn-entry-from');
        entryCounter.removeAttribute('data-mn-ineligible');
      }

      if (priceRow) {
        var price = priceRow.querySelector('.price');
        if (price) {
          price.classList.toggle('price--on-sale', onSale);
          price.classList.remove('price--no-compare', 'price--sold-out', 'volume-pricing--sale-badge');
        }
        priceRow.querySelectorAll('.price__regular .price-item--regular:not(.variant-item__old-price)').forEach(function(node) {
          node.textContent = formatted;
        });
        var sale = priceRow.querySelector('.price__sale');
        if (sale) {
          var salePrice = sale.querySelector('.price-item--sale.price-item--last');
          if (salePrice) salePrice.textContent = formatted;
          var oldPrice = sale.querySelector('s.price-item--regular');
          if (!oldPrice && onSale) {
            var oldPriceWrapper = document.createElement('span');
            oldPrice = document.createElement('s');
            oldPrice.className = 'price-item price-item--regular';
            oldPriceWrapper.appendChild(oldPrice);
            sale.insertBefore(oldPriceWrapper, sale.firstChild);
          }
          if (oldPrice) oldPrice.textContent = onSale ? formatCardMoney(compareAt) : '';
          var percentage = sale.querySelector('.price-item--percent');
          if (percentage) percentage.textContent = onSale ? '(-' + Math.round((compareAt - cents) * 100 / compareAt) + '%)' : '';
        }
      }
      if (window.MNGiveaway) window.MNGiveaway.render();

      // Swap the product card image to the variant's image
      if (variant.featured_image && variant.featured_image.src) {
        var img = findCardImage(picker);
        if (!img) return;

        var base = variant.featured_image.src.replace(/\?.*$/, '');
        img.src = base + '?width=800&format=webp';
        img.srcset = base + '?width=240&format=webp 240w, '
          + base + '?width=352&format=webp 352w, '
          + base + '?width=650&format=webp 650w, '
          + base + '?width=832&format=webp 832w, '
          + base + '?width=1200&format=webp 1200w';
        img.alt = variant.featured_image.alt || '';
      }
    }
  })();
